import { render } from "./VehicleBenefits.vue?vue&type=template&id=305fcd15"
import script from "./VehicleBenefits.vue?vue&type=script&lang=js"
export * from "./VehicleBenefits.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/VehicleBenefits.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "305fcd15"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('305fcd15', __exports__)) {
    api.reload('305fcd15', __exports__)
  }
  
  module.hot.accept("./VehicleBenefits.vue?vue&type=template&id=305fcd15", () => {
    api.rerender('305fcd15', render)
  })

}


export default __exports__